import React, { Component } from "react";

// Custom Module
import request from "../../../lib/requester";
import _ from "lodash";

// Downloaded Module
import { Loader } from "react-overlay-loader";
import ReactTable from "react-table";
import "react-table/react-table.css";

class ListMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(window.localStorage.getItem("is_user")),
      selectedBranchId: "",
      selectedBranchCode: "",
      lov_branch: [],
      loading: false,
    };
  }

  componentDidMount = () => {
    this.getList();
  };

  getList = async () => {
    let url = "/api/traces_chd/v1/recommendation/list-approval";
    let param = {}
    this.setState({ loading: true });
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({
          dataTable: data,
          loading: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  handleChangeBranch = (e) => {
    let value = e.target.value;
    this.setState({ selectedBranch: value });
  };

  renderBranch = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group row">
                    <label>Branch</label>
                    <select
                      className="form-control"
                      value={this.state.selectedBranchId}
                      onChange={this.handleChangeBranch.bind(this)}
                      disabled={true}
                    >
                      <option value="">- Select Branch -</option>
                      <option value={"ALL"}>ALL</option>
                      {this.state.lov_branch.map((item, index) => (
                        <option value={item.org_id}>{item.org_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderTable = () => {
    let app = this;
    const data = {
      columns: [
        {
          Header: "RAYON",
          accessor: "RAYON",
          filterable: true,
        },
        {
          Header: "CHANNEL OTC",
          accessor: "CHANNEL_OTC",
          filterable: true,
          width: 200,
        },
        {
          Header: "GROUP MODERN",
          accessor: "GROUP_MODERN",
          filterable: true,
          width: 300,
        },
        {
          Header: "PILAR",
          accessor: "PILAR",
          filterable: true,
        },
        {
          Header: "OUTLET ID SUBDIST",
          accessor: "OUTLET_ID_SUBDIST",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET CODE SUBDIST",
          accessor: "OUTLET_CODE_SUBDIST",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET NAME SUBDIST",
          accessor: "OUTLET_NAME_SUBDIST",
          filterable: true,
          width: 300,
        },
        {
          Header: "OUTLET ID AAM",
          accessor: "OUTLET_ID_AAM",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET CODE AAM",
          accessor: "OUTLET_CODE_AAM",
          filterable: true,
          width: 200,
        },
        {
          Header: "OUTLET NAME AAM",
          accessor: "OUTLET_NAME_AAM",
          filterable: true,
          width: 300,
        },
        {
          Header: "BRANCH DESC",
          accessor: "BRANCH_DESC_AAM",
          filterable: true,
          width: 200,
        },
        {
          Header: "FLAG CUSTOMER",
          accessor: "FLAG_CUSTOMER",
          filterable: true,
          width: 200,
        },
        {
          Header: "FLAG MAPPING OUTLET",
          accessor: "FLAG_MAPPING_OUTLET",
          filterable: true,
          width: 200,
        },
        {
          Header: "FLAG MAPPING RAYON",
          accessor: "FLAG_MAPPING_RAYON",
          filterable: true,
          width: 200,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="-striped -highlight"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
        getTrProps={(state, row) => {
          return {
            onClick: function () {
              app.props.history.push(
                "/admin/recommendation-chd/detail-approval/" + row.original.ID
              );
            },
          };
        }}
      />
    );
  };

  renderMessage = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="alert alert-warning"><i className="fa fa-exclamation-triangle"></i> Click row to select outlet</div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">
                    <i className="fa fa-file" /> List Approval
                  </div>
                  <div className="card-body">
                    {this.renderMessage()}
                    {this.renderTable()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default ListMaster;
